import * as Sentry from '@sentry/browser'

import { programaDeFidelidade } from '../js/pages/ProgramaDeFidelidade/ProgramaDeFidelidade'
import { newDialog } from './components/Dialog/Dialog'
import templateInformacoesCliente from './components/Dialog/SolicitaTelefone.hbs'
import { gif, loader, showMessageBox, toast } from './components/message'
import { estabelecimento } from './Estabelecimento/estabelecimento'
import {
  carregaEnderecos,
  mensagemBeneficioDisponiveis,
  saveError,
} from './mobile'
import { buscaBairrosMogoSmart } from './pages/Enderecos/Enderecos'
import { usuario } from './usuario'
import { telaCadastroFidelidade } from './components/fidelidade/fidelidade'

export const onlyNumber = (string) => Number(string.match(/\d+/g).join(''))

export const getUrlAction = (cController, cAcao) => {
  const cUrl =
    location.href.substring(0, location.href.indexOf('//') + 2) +
    location.host +
    '/' +
    cController +
    '/' +
    cAcao
  return cUrl
}

export const inputIsValid = (input, message, custom) => {
  if (input.nodeName === 'SELECT') {
    if (input.selectedOptions[0] == input.options[0]) {
      input.setCustomValidity(message || 'Selecione uma opção')
      input.reportValidity()
      return false
    }
  }

  if (!input.value) {
    if (message) {
      input.setCustomValidity(message)
    }

    if ($(input).is(':visible')) {
      input.reportValidity()
    } else {
      return false
    }

    return false
  } else {
    if (custom && custom.test) {
      if (custom.test(input)) {
        return true
      } else {
        input.setCustomValidity(custom.message || 'Campo inválido')
        input.reportValidity()
      }
    } else {
      return true
    }
  }
}

export const format = {
  date: (date) =>
    new Intl.DateTimeFormat('pt', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date),
  hour: (hour) =>
    new Intl.DateTimeFormat('pt', {
      hour: 'numeric',
      minute: 'numeric',
    }).format(hour),
  money: (val) =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(val),
}

export const isEmpty = (input) => {
  if (input.value == '') {
    input.style.borderColor = '#ff304f'
    return true
  } else {
    return false
  }
}

export const getScroll = () => {
  if (window.pageYOffset != undefined) {
    return [pageXOffset, pageYOffset]
  } else {
    let sx
    let sy
    const d = document
    const r = d.documentElement
    const b = d.body
    sx = r.scrollLeft || b.scrollLeft || 0
    sy = r.scrollTop || b.scrollTop || 0
    return [sx, sy]
  }
}

export const elementHeigth = (element, options) => {
  const computedStyle = getComputedStyle(element)
  let margin = 0
  if (options && options.margin) {
    margin += onlyNumber(computedStyle.marginTop)
    margin += onlyNumber(computedStyle.marginBottom)
  }
  const heigth = element.getBoundingClientRect().height

  return heigth + margin
}

export const ripple = (element) => {
  try {
    $(element).on('mousedown', function (e) {
      const $self = $(this)

      if ($self.is('.btn-disabled')) {
        return
      }
      if ($self.closest('[data-ripple]')) {
        e.stopPropagation()
      }

      const initPos = $self.css('position')
      const offs = $self.offset()
      const x = e.pageX - offs.left
      const y = e.pageY - offs.top
      const dia = Math.min(this.offsetHeight, this.offsetWidth, 100) // start diameter
      const $ripple = $('<div/>', { class: 'ripple', appendTo: $self })

      if (!initPos || initPos === 'static') {
        $self.css({ position: 'relative' })
      }

      $('<div/>', {
        class: 'rippleWave',
        css: {
          background: $self.data('ripple'),
          width: dia,
          height: dia,
          left: x - dia / 2,
          top: y - dia / 2,
        },
        appendTo: $ripple,
        one: {
          animationend: function () {
            $ripple.remove()
          },
        },
      })
    })
  } catch {
    Sentry.captureException('Erro ao tentar aplicar o efeito ripple')
  }
}

export const goToLogin = () => {
  location.href =
    location.origin +
    '/Account/LoginPage?urlRef=' +
    location.pathname.replace('/', '')
}

export const random = () => {
  return Math.floor(Math.random() * 9999999999)
}

// Renorna um valor específico de parents de um elemento
export const parent = (target, n) => {
  for (let i = 0; i < n; i++) {
    target = target.parentNode
  }
  return target
}

export const formatAddress = (address) => {
  if (address) {
    if (
      !address.strCidade ||
      address.strCidade.length == 0 ||
      address.strCidade.length == 1
    ) {
      address.strCidade = address.cidadeStr || estabelecimento.endereco.cidade
    }

    return (
      [
        address.Rua || address.rua || '',
        address.Numero || address.numero || '',
        'Bairro ' + (address.StrBairro || address.bairroStr || ''),
        address.strCidade || address.cidadeStr || address.StrCidade || '',
        address.strEstado || address.estadoStr || address.StrEstado || '',
        'Brasil',
        (address.CEP || address.cep) ? 'CEP: ' + (address.CEP || address.cep || '') : '',
      ]
        .filter((string) => string != '' && string != undefined)
        .join(', ') + '.'
    )
  } else {
    return ''
  }
}

export const newPage = (options) => {
  const page = document.createElement('div')
  page.id = options.id ? options.id : 'pg' + random()
  page.classList = `u-page u-viewport ${options.classList ? options.classList : 'animate__top-level'
    }`
  page.style.height = window.innerHeight + 'px'
  page.innerHTML = `  
        <div class="app-bar">
            <img src="/images/global/arrow-left.svg">
            <span>${options.appbarTitle}</span>
        </div>
        <div class="page-body ${options.bodyClassList || ''}">
            ${options.body ? options.body : gif.start('', 'gif-container')}
        </div>`

  const body = document.body
  const app = select('#app')
  const closeButtom = page.querySelector('.app-bar img')
  const scrollTop = getScroll()[1]

  body.appendChild(page)

  ripple(closeButtom)
  closeButtom.addEventListener('click', (event) => {
    const close = () => {
      page.remove()
    }

    if (options.beforeClose) {
      if (isFunction(options.beforeClose)) {
        options.beforeClose(event)
      }
    }

    if (options.close) {
      if (isFunction(options.close)) {
        options.close(close)
      }
    } else {
      close()
    }

    if (options.afterClose) {
      if (isFunction(options.afterClose)) {
        options.afterClose(event)
      }
    }

    bagButtonShow()
  })

  if (options.callback) {
    if (isFunction(options.callback)) {
      options.callback(page.id, select('.page-body', page))
    } else {
      throw new Error('Callback is not a function')
    }
  }

  return page
}

export const bagButtonShow = () => {
  const buttomPedido = select('#btn-pedido')
  setTimeout(() => {
    buttomPedido && buttomPedido.classList.add('visible')
  }, 400)
}

export const sentryError = {
  checkObject(wrapper) {
    for (const key in wrapper) {
      if (!wrapper[key] && typeof wrapper[key] !== 'function') {
        throw new Error(estabelecimento.fantasia + `: Valor é null: ${key}`)
      }
    }
  },

  exception(exc) {
    Sentry.captureException(exc)
  },
}

// Mapeamento de interações
export const track = (nome, atributos) => {
  if (usuario.cookies.consentimentoMixpanel === '') {
    window.trackAwait.push({ nome, atributos })
  } else if (usuario.cookies.consentimentoMixpanel == true) {
    try {
      const localhost = window.location.host.includes('localhost')
      if (!localhost && !isDebug) {
        if (!atributos) {
          atributos = {}
        }

        atributos.url = window.location.href
        atributos.estabelecimento = estabelecimento.fantasia
        atributos.qrCode = estabelecimento.qrCode.ativo

        mixpanel.track(nome, atributos)
      }
    } catch (e) {
      sentryError.exception('MixPanel -' + e)
    }
  }
}

const isFunction = (target) => {
  return target && typeof target === 'function'
}

String.prototype.camelCase = function () {
  return (
    this.slice(0, 1).toUpperCase() + this.slice(1, this.length).toLowerCase()
  )
}

export const detectCard = (number) => {
  const cardnumber = number.replace(/[^0-9]+/g, '')
  const cards = {
    visa: /^4[0-9]{12}(?:[0-9]{3})/,
    mastercard: /^5[1-5][0-9]{14}/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    amex: /^3[47][0-9]{13}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    hypercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
    aura: /^(5078\d{2})(\d{2})(\d{11})$/,
  }

  for (const flag in cards) {
    if (cards[flag].test(cardnumber)) {
      return flag
    }
  }

  return "credit-card"
}

export const errorInput = (wrapperInput, message) => {
  const messageSpan = wrapperInput.querySelector('.error-message')
  messageSpan && messageSpan.remove()
  const messageWrapper = document.createElement('span')
  messageWrapper.textContent = message
  messageWrapper.classList = 'error-message'
  wrapperInput.appendChild(messageWrapper)
  wrapperInput.classList.add('input-error')
}

export const TestaCPF = (cpf) => {
  if (cpf) {
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf == '') return false
    // Elimina CPFs invalidos conhecidos
    if (
      cpf.length != 11 ||
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    )
      return false
    // Valida 1o digito
    let add = 0

    for (var i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i)) * (10 - i)
    }

    let rev = 11 - (add % 11)

    if (rev == 10 || rev == 11) {
      rev = 0
    }

    if (rev != parseInt(cpf.charAt(9))) {
      return false
    }

    // Valida 2o digito
    add = 0
    for (i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i)
    }
    rev = 11 - (add % 11)
    if (rev == 10 || rev == 11) {
      rev = 0
    }
    if (rev != parseInt(cpf.charAt(10))) {
      return false
    }
    return true
  } else {
    return false
  }
}

export const SaveException = (erro = '', funcao = '', json = '') => {
  axios
    .get(getUrlAction('Home', 'SaveExeption'), {
      params: {
        erro,
        funcao,
        json,
      },
    })
    .catch((e) => {
      sentryError.exception('SaveException -' + e)
    })
}

/* PIZZAS */
export function formatDecimal(n, format) {
  if (typeof format === 'undefined') format = 'n'
  if (typeof n === 'string') {
    n = n.parseNumber()
  }
  let result = '0'
  try {
    result = Globalize.format(n, format)
    if (!result) result = '0'
  } catch (e) {
    result = '0'
  }
  result = result.replace('.', '')
  return result
}

export const solicitaInformacoesUsuario = (somenteTelefone, callback) => {

  const nome = localStorage.getItem('nome-cliente')
  const telefone = localStorage.getItem('telefone-cliente')
  const cpf = localStorage.getItem('cpf-cliente')

  newDialog({
    body: templateInformacoesCliente({
      somenteTelefone,
      nome: estabelecimento.qrCode.nomeCliente,
      telefone: '',
    }),
    classList: !somenteTelefone ? 'dialog-info-cliente' : '',
    callback: (wrapper) => {
      const input = wrapper.querySelector('#telefone')
      const inputNome = wrapper.querySelector('#nome')
      const inputCPF = wrapper.querySelector('#cpf')

      if (nome) {
        inputNome.value = nome
      }

      if (telefone) {
        input.value = telefone
      }

      if (cpf) {
        inputCPF.value = cpf
      }

      IMask(input, {
        mask: '(00)00000-0000',
      })

      if (inputCPF) {
        IMask(inputCPF, {
          mask: '000.000.000-00',
        })
      }

      const [buttonCancel, buttonContinue] = selectAll(
        '.dialog-buttons button',
        wrapper,
      )

      buttonCancel &&
        buttonCancel.addEventListener('click', () => {
          wrapper.remove()
        })

      buttonContinue.addEventListener('click', () => {
        // Valida se o telefone foi preenchido



        if (inputCPF) {
          const sucesso = TestaCPF(inputCPF.value)

          if (!sucesso) {
            inputReport(inputCPF, 'CPF inválido')
            return
          }
        }

        if (validaTelefone(input)) {
          const telefone = input.value
          const cpf = inputCPF ? inputCPF.value : ''

          if (!estabelecimento.qrCode.ativo) {
            // Salva o telefone no cadastro do usuário
            axios
              .get(getUrlAction('Cadastros', 'SetUserPhone'), {
                params: {
                  telefone: input.value,
                },
              })
              .then(function ({ data }) { })
              .catch(function (error) {
                sentryError.exception(error)
              })
          }

          // Valida se o nome foi preenchido
          if (!somenteTelefone && inputNome && inputIsValid(inputNome)) {
            const nome = inputNome.value
            wrapper.remove()

            localStorage.setItem('nome-cliente', nome)
            localStorage.setItem('telefone-cliente', telefone)
            localStorage.setItem('cpf-cliente', cpf)

            callback({ nome, telefone, cpf })
          } else if (!inputNome) {
            usuario.telefone = telefone
            wrapper.remove()

            localStorage.setItem('telefone-cliente', telefone)

            callback(telefone)
          }
        }
      })
    },
  })
}

export const inputReport = (input, message) => {
  // Cria o elemento span que vai receber a mensagem de erro
  const spanMessage = createElement('span', {
    class: 'font-12 font-red',
  })
  spanMessage.textContent = message
  insertAfter(input, spanMessage)

  // Adiciona a cor de erro no input
  input.style.boxShadow =
    'rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(255 48 79 / 76%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px'

  // Cria o listener para remover a classe de erro quando o input for alterado
  const listenerRemoveReport = () => {
    input.addEventListener('input', () => {
      input.style.boxShadow = ''
      input.removeEventListener('input', listenerRemoveReport)
    })
  }
}

export function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}

export function createElement(type, attributes, content) {
  const element = document.createElement(type)
  for (const key in attributes) element.setAttribute(key, attributes[key])

  if (content) {
    if (Array.isArray(content)) {
      content.forEach(item => {
        if (!item) return
        if (item.nodeName) {
          element.appendChild(item)
        } else {
          element.innerHTML += item
        }
      })
    } else if (content.nodeName) {
      element.appendChild(content)
    } else {
      element.innerHTML = content
    }
  }

  return element
}

const validaTelefone = (input) => {
  if (!input.value) {
    inputReport(input, 'Preencha o campo antes de continuar')
    return false
  }

  if (input.value.length < 13) {
    inputReport(input, 'O telefone é inválido')
    return false
  }

  return true
}

export const createPage = (config) => {
  const wrapper = createElement('div', { class: 'dialog-wrapper' })
  const page = createElement('div', { class: 'dialog-main' })

  if (config.class) {
    wrapper.classList.add(config.class)
  }

  if (!config.enableSelect) {
    wrapper.classList.add('no-select')
  }

  wrapper.appendChild(page)
  wrapper.addEventListener('click', (event) => {
    if (event.target != page && !page.contains(event.target)) {
      wrapper.remove()
    }
  })

  if (config.header) {
    const header = createElement('div', { class: 'dialog-header' })
    header.innerHTML = `
      <div class="flex flex-between">
        <div class="u-font-14 font-500">${config.header.title || ''}</div>
        <div class="dialog-close-button">
          <svg class="close-button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.72001 3.72003C3.86063 3.57958 4.05126 3.50069 4.25001 3.50069C4.44876 3.50069 4.63938 3.57958 4.78001 3.72003L8.00001 6.94003L11.22 3.72003C11.2887 3.64634 11.3715 3.58724 11.4635 3.54625C11.5555 3.50526 11.6548 3.48322 11.7555 3.48144C11.8562 3.47966 11.9562 3.49819 12.0496 3.53591C12.143 3.57363 12.2278 3.62977 12.299 3.70099C12.3703 3.77221 12.4264 3.85705 12.4641 3.95043C12.5018 4.04382 12.5204 4.14385 12.5186 4.24455C12.5168 4.34526 12.4948 4.44457 12.4538 4.53657C12.4128 4.62857 12.3537 4.71137 12.28 4.78003L9.06001 8.00003L12.28 11.22C12.3537 11.2887 12.4128 11.3715 12.4538 11.4635C12.4948 11.5555 12.5168 11.6548 12.5186 11.7555C12.5204 11.8562 12.5018 11.9562 12.4641 12.0496C12.4264 12.143 12.3703 12.2278 12.299 12.299C12.2278 12.3703 12.143 12.4264 12.0496 12.4641C11.9562 12.5018 11.8562 12.5204 11.7555 12.5186C11.6548 12.5168 11.5555 12.4948 11.4635 12.4538C11.3715 12.4128 11.2887 12.3537 11.22 12.28L8.00001 9.06003L4.78001 12.28C4.63783 12.4125 4.44978 12.4846 4.25548 12.4812C4.06118 12.4777 3.8758 12.399 3.73838 12.2616C3.60097 12.1242 3.52226 11.9388 3.51883 11.7445C3.5154 11.5502 3.58753 11.3622 3.72001 11.22L6.94001 8.00003L3.72001 4.78003C3.57956 4.63941 3.50067 4.44878 3.50067 4.25003C3.50067 4.05128 3.57956 3.86066 3.72001 3.72003Z" fill="#24292E"></path>
          </svg>
        </div>
      </div>
      `
    const closeButton = select('.dialog-close-button', header)
    closeButton.addEventListener('click', () => {
      wrapper.remove()
    })
    page.appendChild(header)
  }

  const body = createElement('div', { class: 'dialog-body' })
  page.appendChild(body)

  if (config.beforeAppend) {
    config.beforeAppend({
      wrapper,
      page,
      body,
    })
  }

  document.body.appendChild(wrapper)

  return {
    wrapper,
    page,
  }
}

export const createMessageBox = (config) => {
  if (!config) {
    console.error('Configuração não informada')
    return
  }

  const wrapperContent = createElement('div', { class: 'message-card u-relative' })

  if (config.widthMessageCard) {
    wrapperContent.style.width = config.widthMessageCard
  }

  if (config.closeButton) {
    wrapperContent.innerHTML += `
    <svg class="close-button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.72001 3.72003C3.86063 3.57958 4.05126 3.50069 4.25001 3.50069C4.44876 3.50069 4.63938 3.57958 4.78001 3.72003L8.00001 6.94003L11.22 3.72003C11.2887 3.64634 11.3715 3.58724 11.4635 3.54625C11.5555 3.50526 11.6548 3.48322 11.7555 3.48144C11.8562 3.47966 11.9562 3.49819 12.0496 3.53591C12.143 3.57363 12.2278 3.62977 12.299 3.70099C12.3703 3.77221 12.4264 3.85705 12.4641 3.95043C12.5018 4.04382 12.5204 4.14385 12.5186 4.24455C12.5168 4.34526 12.4948 4.44457 12.4538 4.53657C12.4128 4.62857 12.3537 4.71137 12.28 4.78003L9.06001 8.00003L12.28 11.22C12.3537 11.2887 12.4128 11.3715 12.4538 11.4635C12.4948 11.5555 12.5168 11.6548 12.5186 11.7555C12.5204 11.8562 12.5018 11.9562 12.4641 12.0496C12.4264 12.143 12.3703 12.2278 12.299 12.299C12.2278 12.3703 12.143 12.4264 12.0496 12.4641C11.9562 12.5018 11.8562 12.5204 11.7555 12.5186C11.6548 12.5168 11.5555 12.4948 11.4635 12.4538C11.3715 12.4128 11.2887 12.3537 11.22 12.28L8.00001 9.06003L4.78001 12.28C4.63783 12.4125 4.44978 12.4846 4.25548 12.4812C4.06118 12.4777 3.8758 12.399 3.73838 12.2616C3.60097 12.1242 3.52226 11.9388 3.51883 11.7445C3.5154 11.5502 3.58753 11.3622 3.72001 11.22L6.94001 8.00003L3.72001 4.78003C3.57956 4.63941 3.50067 4.44878 3.50067 4.25003C3.50067 4.05128 3.57956 3.86066 3.72001 3.72003Z" fill="#24292E"/>
    </svg>
    `

    const closeButtom = select('.close-button', wrapperContent)
    closeButtom.addEventListener('click', () => {
      wrapper.remove()
    })
  }

  // #region Cabeçalho
  let cabecalho = ''

  cabecalho += `<div class="flex flex-between">`

  if (config.title) {
    cabecalho += `
    <div class="u-m-8-0">
      <div class="font-14 font-500">${config.title}</div>`

    if (config.subtitle) {
      cabecalho += `<div class="font-12 u-m-t-3">${config.subtitle}</div>`
    }
    cabecalho += `</div>`
  }

  if (config.closeButtom) {
    cabecalho += `<i class="fa fa-times" aria-hidden="true"></i>`
  }
  cabecalho += `</div>`

  if (!config.closeButtom && !config.title) {
    cabecalho = ''
  }
  wrapperContent.innerHTML += cabecalho

  const closeButtom = select('.close-button', wrapperContent)
  if (closeButtom) {
    closeButtom.addEventListener('click', () => {
      wrapper.remove()
    })
  }

  // #endregion Cabeçalho

  if (config.content) {
    if (config.content.nodeName) {
      wrapperContent.appendChild(config.content)
    } else {
      wrapperContent.innerHTML += `<div class="w-100  font-14 font-weight-500">${config.content || ''}</div>`
    }
  }
  const wrapper = createElement('div', { class: 'message-box ' + (config.class || "") }, wrapperContent)

  if (config.buttons) {
    const wrapperButtons = createElement('div', {
      class: 'wrapper-buttons flex flex-column gap-8 w-100',
    })
    wrapperContent.appendChild(wrapperButtons)

    config.buttons.forEach((button) => {
      // Cria o botão, adiciona o listener de click e faz o append no wrapper
      const buttonNode = createElement(
        'button',
        { class: button.class || 'btn-azul' },
        button.content,
      )
      buttonNode.addEventListener('click', () => {
        button.callback(wrapper)
      })
      wrapperButtons.appendChild(buttonNode)
    })
  }

  if (config.closeOnClickOutside) {
    wrapper.addEventListener('click', (e) => {
      if (e.target != wrapperContent && !wrapperContent.contains(e.target)) {
        wrapper.remove()
      }
    })
  }

  if (config.beforeAppend) {
    config.beforeAppend(wrapper)
  }

  document.body.appendChild(wrapper)

  if (config.afterAppend) {
    config.afterAppend(wrapper)
  }

  return wrapper
}

export const loginMessage = (callback) => {
  createMessageBox({
    class: 'mensagem-login',
    content: 'Escolha uma das opções abaixo para continuar seu pedido',
    closeOnClickOutside: true,
    buttons: [
      {
        content: `
        <div class="flex gap-4 flex-between">
          <div class="flex flex-column gap-4 text-left">
            <div class="font-14">Fazer login</div>
            <div class="button-subtitle">Entrar ou cadastrar sua conta</div>
          </div>
          <svg class="self-center" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z" fill="currentColor"/>
          </svg>
        </div>
        `,
        class: 'btn-transparent flex-1',
        callback: (wrapper) => {
          wrapper.remove()
          track('login', { tipo: 'cadastro', estabelecimento: estabelecimento.urlServer })
          window.location.href = window.location.origin + '/Account/LoginPage?urlRef=' + estabelecimento.urlEmpresa
        }
      },
      {
        content: `
        <div class="flex gap-4 flex-between">
          <div class="flex flex-column gap-4 text-left">
            <div class="font-14">Continuar sem cadastro</div>
            <div class="button-subtitle-blue">Caso não queira cadastrar um usuário</div>
          </div>
          <svg class="self-center" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21967 3.21967C6.51256 2.92678 6.98744 2.92678 7.28033 3.21967L11.5303 7.46967C11.8232 7.76256 11.8232 8.23744 11.5303 8.53033L7.28033 12.7803C6.98744 13.0732 6.51256 13.0732 6.21967 12.7803C5.92678 12.4874 5.92678 12.0126 6.21967 11.7197L9.93934 8L6.21967 4.28033C5.92678 3.98744 5.92678 3.51256 6.21967 3.21967Z" fill="currentColor"/>
          </svg>
        </div>
        `,
        callback: (wrapper) => {
          wrapper.remove()
          track('login', { tipo: 'sem cadastro', estabelecimento: estabelecimento.urlServer })
          continuarSemLogar(callback)
        },
        class: 'btn-azul flex-1',
      },
    ],
  })
}

export const notificationBox = (message, callback) => {
  const wrapper = createElement(
    'div',
    { class: 'notification-box' },
    `
    <div class="notification-box-content">
      <div class="flex flex-column gap-16">
        <div class="font-16 font-500 text-center m-12-0">${message}</div>
          <button class="btn-azul w-100">Ok</button>
      </div>
    </div>
    `,
  )

  const button = select('.btn-azul', wrapper)
  button.addEventListener('click', () => {
    wrapper.remove()
    if (callback) callback()
  })

  document.body.appendChild(wrapper)
}

export const storage = {
  set: (propertyName, itemToSave) => {
    const json = JSON.stringify(itemToSave)
    let salvo = false

    try {
      localStorage.setItem(propertyName, json)
      salvo = true
    } catch (error) {
      Sentry.captureException(error)
      console.error('Não foi possível salvar o item no localStorage')
    }

    if (!salvo) {
      try {
        sessionStorage.setItem(propertyName, json)
        salvo = true
      } catch (error) {
        Sentry.captureException(error)
        console.error('Não foi possível salvar o item no sessionStorage')
      }
    }

    if (!salvo) {
      storage.temp[propertyName] = itemToSave
    }
  },

  get: (propertyName) => {
    let item = null

    try {
      item = localStorage.getItem(propertyName)
    } catch (error) {
      Sentry.captureException(error)
      console.error('Não foi possível buscar o item no localStorage')
    }

    if (!item) {
      try {
        item = sessionStorage.getItem(propertyName)
      } catch (error) {
        Sentry.captureException(error)
        console.error('Não foi possível buscar o item no sessionStorage')
      }
    }

    if (!item) {
      item = storage.temp[propertyName]
    }

    if (item) {
      let retorno = item

      try {
        retorno = JSON.parse(item)
      } catch {
        retorno = item
      }

      return retorno
    } else {
      console.error(
        '%cstorage:',
        'background: #000; border-radius: 5px; padding: 2px 6px; font-weight:bold; border: 1px solid red',
        'Item não encontrado',
      )
      return null
    }
  },

  remove: (propertyName) => {
    let deleted = false
    try {
      localStorage.removeItem(propertyName)
      deleted = true
    } catch (error) {
      Sentry.captureException(error)
      console.error('Não foi possível remover o item do localStorage')
    }

    try {
      sessionStorage.removeItem(propertyName)
      deleted = true
    } catch (error) {
      Sentry.captureException(error)
      console.error('Não foi possível remover o item do sessionStorage')
    }

    if (storage.temp[propertyName]) {
      delete storage.temp[propertyName]
      deleted = true
    }

    return deleted
  },

  temp: {},
}

export function buttonLoader(button) {
  const innerHTML = button.innerHTML
  let buttonPosition = ''
  let active = false
  return {
    start: () => {
      if (!active) {
        button.setAttribute('loading', 'true')
        active = true
        button.disabled = true
        buttonPosition = button.style.position
        button.style.position = 'relative'
        button.innerHTML = loader('responsive-loader')
      }
    },
    stop: () => {
      if (active) {
        button.setAttribute('loading', 'false')
        active = false
        button.innerHTML = innerHTML
        button.disabled = false
        button.style.position = buttonPosition
      }
    },
    active,
  }
}

export function criaInstanciaGeocoder() {
  return new Promise((resolve, reject) => {
    if (typeof google === 'undefined') {
      if (select('#google-maps-script')) {
        return
      }

      // Criar uma nova versão para não armazenar o javascript no cache do navegador
      const version = random()

      const baseURL = 'https://maps.googleapis.com/maps/api/js?' + version

      let key = ''

      // Keys para produção
      // if(isDebug){
      //   key = 'AIzaSyC-dZ8H5yO7PnY9FM5I-j3TuY_5PTNPtYc'
      // }else{
      //   key = 'AIzaSyD0NR4p2h2LK_8WeZ3zVCGkkt2ezW0l_eQ'
      // }

      // key uso teste Adriano
      key =
        estabelecimento.chaveAPIGoogleMaps ||
        'AIzaSyD0NR4p2h2LK_8WeZ3zVCGkkt2ezW0l_eQ'

      if (isDebug) {
        key = 'AIzaSyBHjUF3J-K1o4knEnXzQBKZtI7NNc4UMHo'
      }
      const callbackName = 'carregaFuncaoPendente'
      const libraries = 'places,geometry&v=weekly'

      const script = createElement('script', {
        async: true,
        src: `${baseURL}&${version}&key=${key}&callback=${callbackName}&libraries=${libraries}`,
        id: 'google-maps-script',
      })

      document.head.appendChild(script)

      window.funcaoPendente = () => {
        estabelecimento.api.geocoder = new google.maps.Geocoder()
        resolve()
      }
    } else {
      resolve()
    }
  })
}

function continuarSemLogar(callBack) {
  try {
    createPage({
      header: {
        title: 'Continuar sem logar',
      },
      class: 'dialog-sem-login',
      beforeAppend: ({ wrapper, body }) => {
        let exibirNome = false
        body.innerHTML = template()

        const inputTermos = select('#termos', body)

        const buttonContinuar = select('#continuar', body)
        const inputTelefone = select('#telefone', body)
        const inputSenha = select('#senha', body)

        IMask(inputTelefone, {
          mask: '(00) 00000-0000',
        })

        buttonContinuar.addEventListener('click', () => {
          if (!inputTermos.checked) {
            inputTermos.reportValidity()
            return
          }

          const inputNome = select('#nome', body)
          const telefone = inputTelefone.value
          const senha = inputSenha.value

          if (inputIsValid(inputTelefone)) {
            if (telefone.length == 15) {
              track('Telefone', { telefone })
              if (inputNome) {
                if (!inputIsValid(inputNome)) {
                  return
                }
                if (
                  inputNome.value.split(' ').length <= 1 ||
                  inputNome.value.split(' ')[1]?.length <= 1
                ) {
                  inputNome.setCustomValidity(
                    'Por favor, digite seu nome completo',
                  )
                  inputNome.reportValidity()
                  return
                }
              }

              const loader = buttonLoader(buttonContinuar)
              loader.start()

              const nome = inputNome ? inputNome.value : ''
              verificaCadastro(telefone, nome, exibirNome, senha)
                .then(({ data }) => {
                  loader.stop()

                  if (data.erro) {
                    toast(data.erro)
                  } else if (data.temSenha && !data.senhaValida) {
                    if (!data.senhaValida && senha != '') {
                      toast('Senha incorreta')
                    } else {
                      usuario.temSenha = data.temSenha

                      const wrapperSenha = select('.wrapper-senha')
                      wrapperSenha.classList.remove('oculto')

                      toast('Informe sua senha antes de continuar')
                    }
                  } else if (data.temSenha && !data.senhaValida) {
                    inputSenha.parentElement.classList.remove('oculto')
                  } else if (data.idUsuario == 0 && data.exibirNome) {
                    exibirNome = true
                    continuaCadastro()
                    toast('Preencha seu nome antes de continuar')
                  } else {
                    usuario.logado = true
                    usuario.semCadastro = true
                    usuario.telefone = telefone
                    usuario.id = data.idUsuario
                    usuario.cartoes = data.cartoes

                    if (data.nome) {
                      usuario.nome = data.nome
                    } else {
                      usuario.nome = nome
                    }

                    loader.start()
                    carregaEnderecos(() => {
                      buscaBairrosMogoSmart(() => {
                        buscaDadosBuscaBalcao((sucesso) => {
                          // Se tiver usuário e o mesmo ainda não tenha UtilizaFidelidade definido
                          // busca os dados do programa de fidelidade
                          if (
                            usuario &&
                            usuario.id &&
                            usuario &&
                            typeof usuario.UtilizaProgramaFidelidade ===
                            'undefined'
                          ) {
                            $.ajax({
                              type: 'GET',
                              url: getUrlAction(
                                'Cadastros',
                                'GetDadosProgramaFidelidade',
                              ),
                              data: { urlEmpresa: estabelecimento.urlEmpresa },
                              success: function (response, status, xhr) {
                                estabelecimento.programaFidelidade =
                                  JSON.parse(response)
                                estabelecimento.programaFidelidade.cliente = {
                                  pontos:
                                    estabelecimento.programaFidelidade
                                      .pontosAtuaisFideliza,
                                  pontosUtilizados:
                                    estabelecimento.programaFidelidade
                                      .pontosUtilizadosFideliza,
                                }

                                mensagemBeneficioDisponiveis()

                                wrapper.remove()
                                loader.stop()

                                const menuVisible = select('.menu-show')
                                if (menuVisible) {
                                  if (
                                    estabelecimento.programaFidelidade.Ativo
                                  ) {
                                    const elementoMenu =
                                      select('#menu-fidelidade')
                                    if (
                                      elementoMenu &&
                                      elementoMenu.style.display === 'none'
                                    ) {
                                      elementoMenu.style.display = ''
                                      elementoMenu.addEventListener(
                                        'click',
                                        () => {
                                          programaDeFidelidade()
                                        },
                                      )
                                    }
                                  }

                                  if (callBack) {
                                    callBack()
                                  } else {
                                    menuVisible.classList.remove('menu-show')
                                    const menu = select('#menu-hambunguer')
                                    menu && menu.click()
                                  }
                                } else {
                                  // const buttonConfirmarPedido = select('#confirmarPedido')
                                  // buttonConfirmarPedido && buttonConfirmarPedido.click()
                                }
                              },
                              error: () => {
                                gif.end()
                              },
                            })
                          }
                        })
                      })
                    })
                  }
                })
                .catch((error) => {
                  loader.stop()
                  toast(
                    'Ocorreu um erro ao verificar seu telefone, tente novamente mais tarde',
                  )
                  console.error(error)
                })
            } else {
              salvaLog(
                estabelecimento.urlEmpresa,
                JSON.stringify({
                  key: 'telefone-invalido',
                  telefone,
                }),
              )

              inputTelefone.setCustomValidity(
                'Por favor, digite o telefone completo',
              )
              inputTelefone.reportValidity()
            }
          }
        })

        function verificaCadastro(telefone, nome, exibirNome, senha) {
          return new Promise((resolve, reject) => {
            axios
              .get(getUrlAction('account', 'CadastraUsuarioTelefone'), {
                params: {
                  telefone,
                  nome,
                  exibirNome,
                  dbName: estabelecimento.urlEmpresa,
                  senha,
                },
              })
              .then((response) => {
                resolve(response)
              })
              .catch((error) => {
                console.error(error)
                Sentry.captureException(error)
                reject(error)
              })
          })
        }

        function continuaCadastro() {
          const formLogin = select('#form-login')
          const wrapper = createElement('div')
          wrapper.innerHTML = `
        <div class="font-12 font-500">Informe seu nome completo</div>
        <div class="input-wrapper">
          <input type="text" id="nome"  placeholder="Nome completo" required>
        </div>
        `
          formLogin.insertBefore(wrapper, buttonContinuar)

          return wrapper.offsetHeight
        }

        function template() {
          return `
          <div id='form-login' class="flex flex-column gap-12">
            <div class="font-12 font-500 font-12">Qual é seu número de telefone?</div>
            <div class="input-wrapper">
              <input id='telefone'  type="text" placeholder="telefone" required >
            </div>
            <label class="gap-4 font-12">
            <input id="termos" type="checkbox" required>
            Eu li e concordo com os <a href="../Home/PoliticaDePrivacidade" target="_blank">termos e condições de uso</a></label>

            <div class="wrapper-senha oculto">
               <div class="font-12 font-500">Digite sua senha antes de continuar</div>
               <div class="input-wrapper">
                  <input id='senha' class="input u-m-t-8" type="password" placeholder="Senha" required>
                </div>  
            </div>
          <button id="continuar" class="btn-azul">Continuar</button>
          </div>
      `
        }
      },
    })
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
  }
}

window.continuarSemLogar = continuarSemLogar
export const salvaLog = (estabelecimento, json) => {
  const str = JSON.stringify({
    DbName: estabelecimento.urlEmpresa,
    JSON: json,
  })
  axios
    .get(getUrlAction('home', 'SalvaLogMogoMenu'), {
      params: {
        str,
      },
    })
    .catch((error) => {
      Sentry.captureException(error)
    })
}

export const buscaDadosBuscaBalcao = (callback) => {
  if (usuario.logado) {
    axios
      .get(getUrlAction('Pedido', 'GetIdVemBuscar'))
      .then(({ data }) => {
        if (data && data.CodObsEntrega) {
          window.codigoBuscaBalcao = data.CodObsEntrega.toString()
          estabelecimento.codigoBuscaBalcao = data.CodObsEntrega.toString()
        } else {
          saveError('Não foi encontrado o Cod Obs Entrega', data)
        }

        callback && callback(false)
      })
      .catch(function (error) {
        console.error(error)
        callback && callback(false)
      })
  } else {
    console.error('Usuário não logado')
  }
}

export const exibeMensagemInput = (input, tipo, mensagem) => {
  const config = {
    error: {
      color: '#EB484C',
    },
    alert: {
      color: '#FFC107',
    },
    success: {
      color: '#5FCE86',
    },
  }

  const mensagemSpan = createElement(
    'span',
    {
      style: `color: ${config[tipo].color}`,
      class: 'font-12 font-500',
    },
    mensagem,
  )

  // Ao receber o foco o input remove a mensagem de erro
  const listener = () => {
    input.parentElement.removeChild(mensagemSpan)
    input.style.borderColor = ''
    input.removeEventListener('blur', listener)
  }

  input.style.borderColor = config[tipo].color
  input.parentElement.appendChild(mensagemSpan)
  input.addEventListener('blur', listener)
}

export const brands = (brand) => {
  const svg = {
    americanexpress: `
      <svg width="45" height="30" viewBox="0 0 45 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.543 24.395V14.4277L44.0241 14.444V17.1972L42.0034 19.3878L44.0241 21.5996V24.4107H40.7983L39.084 22.4912L37.3815 24.4186L26.543 24.395Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M27.7109 23.3017V15.5244H34.2095V17.316H29.8155V18.5324H34.1048V20.2944H29.8155V21.489H34.2095V23.3017H27.7109Z" fill="#1D71B9"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M34.1772 23.3016L37.7724 19.4087L34.1772 15.5249H36.9599L39.1572 17.9896L41.3605 15.5249H44.0242V15.5859L40.5051 19.4087L44.0242 23.1917V23.3016H41.3337L39.0977 20.8122L36.8844 23.3016H34.1772Z" fill="#1D71B9"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3587 5.5813H31.5725L33.0526 8.99187V5.5813H38.255L39.152 8.13651L40.0519 5.5813H44.0243V15.548H23.0312L27.3587 5.5813Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.157 6.66431L24.7563 14.435H27.0887L27.7299 12.8788H31.2062L31.8474 14.435H34.2375L30.8511 6.66431H28.157ZM28.4491 11.1349L29.4687 8.66115L30.4876 11.1349H28.4491Z" fill="#1D71B9"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2061 14.4338V6.66309L37.4843 6.67456L39.1712 11.4518L40.8695 6.66309H44.0245V14.4338L41.9943 14.4519V9.11387L40.0778 14.4338H38.2242L36.2678 9.09576V14.4338H34.2061Z" fill="#1D71B9"/>
      </svg>    
    `,
    mastercard: `
      <svg width="44" height="30" viewBox="0 0 44 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path d="M25.9493 7.59546H17.8291V22.4045H25.9493V7.59546Z" fill="#FF5F00"/>
      <path d="M18.345 15.0016C18.3435 13.5752 18.6618 12.1671 19.2759 10.884C19.89 9.60093 20.7838 8.47646 21.8895 7.59576C20.5204 6.50391 18.8763 5.82495 17.145 5.63649C15.4137 5.44802 13.665 5.75765 12.0989 6.52999C10.5328 7.30233 9.21242 8.50622 8.28865 10.0041C7.36488 11.5019 6.875 13.2333 6.875 15.0003C6.875 16.7673 7.36488 18.4987 8.28865 19.9965C9.21242 21.4943 10.5328 22.6982 12.0989 23.4706C13.665 24.2429 15.4137 24.5525 17.145 24.3641C18.8763 24.1756 20.5204 23.4966 21.8895 22.4048C20.7841 21.5244 19.8906 20.4003 19.2765 19.1177C18.6624 17.8351 18.3439 16.4276 18.345 15.0016Z" fill="#EB001B"/>
      <path d="M36.905 15.0012C36.905 16.7684 36.415 18.4998 35.4911 19.9977C34.5671 21.4956 33.2465 22.6995 31.6802 23.4717C30.1139 24.2439 28.3651 24.5534 26.6337 24.3646C24.9023 24.1759 23.2582 23.4966 21.8892 22.4044C22.9941 21.5232 23.8874 20.3989 24.5017 19.1162C25.1159 17.8335 25.4351 16.426 25.4351 14.9999C25.4351 13.5738 25.1159 12.1663 24.5017 10.8836C23.8874 9.60095 22.9941 8.47659 21.8892 7.59539C23.2582 6.50319 24.9023 5.82391 26.6337 5.63517C28.3651 5.44643 30.1139 5.75587 31.6802 6.5281C33.2465 7.30032 34.5671 8.50419 35.4911 10.0021C36.415 11.5 36.905 13.2315 36.905 14.9986V15.0012Z" fill="#F79E1B"/>
      </svg>    
    `,
    visa: `
      <svg width="44" height="30" viewBox="0 0 44 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path d="M22.5664 13.2245C22.5476 14.7309 23.8893 15.5715 24.9 16.0713C25.9385 16.5841 26.2873 16.913 26.2834 17.3715C26.2754 18.0734 25.455 18.3831 24.687 18.3952C23.3473 18.4163 22.5684 18.0281 21.9491 17.7345L21.4665 20.0262C22.0878 20.3168 23.2383 20.5702 24.4313 20.5813C27.2317 20.5813 29.0638 19.1785 29.0738 17.0035C29.0847 14.2432 25.3113 14.0903 25.337 12.8565C25.346 12.4824 25.6977 12.0832 26.4687 11.9816C26.8502 11.9303 27.9035 11.8911 29.0975 12.4492L29.5662 10.2319C28.9241 9.99459 28.0987 9.76733 27.0711 9.76733C24.4353 9.76733 22.5813 11.1892 22.5664 13.2245ZM34.0699 9.95838C33.5586 9.95838 33.1276 10.2611 32.9353 10.7257L28.935 20.4184H31.7334L32.2903 18.8567H35.7099L36.0329 20.4184H38.4993L36.347 9.95838H34.0699ZM34.4613 12.7841L35.2689 16.7118H33.0572L34.4613 12.7841ZM19.1736 9.95838L16.9678 20.4184H19.6343L21.8391 9.95838H19.1736ZM15.2288 9.95838L12.4532 17.0779L11.3305 11.0243C11.1987 10.3486 10.6785 9.95838 10.1008 9.95838H5.56342L5.5 10.2621C6.43146 10.4672 7.48975 10.7981 8.13087 11.152C8.52327 11.3682 8.63524 11.5573 8.76406 12.0711L10.8906 20.4184H13.7087L18.0291 9.95838H15.2288Z" fill="white"/>
      </svg>    
    `,
    elo: `
      <svg width="44" height="30" viewBox="0 0 44 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path d="M10.4139 11.4301C10.7664 11.3091 11.1448 11.246 11.5388 11.246C13.2598 11.246 14.6957 12.4875 15.0223 14.134L17.4587 13.629C16.8988 10.8304 14.4625 8.72095 11.5388 8.72095C10.8701 8.72095 10.2273 8.83142 9.62598 9.03658L10.4139 11.4301Z" fill="#FFF100"/>
      <path d="M7.53724 19.4471L9.18569 17.5533C8.44959 16.8905 7.98823 15.9278 7.98823 14.8494C7.98823 13.7762 8.44959 12.8083 9.18569 12.1507L7.53724 10.2622C6.28794 11.388 5.5 13.024 5.5 14.8546C5.5 16.6801 6.28794 18.3213 7.53724 19.4471Z" fill="#00A3DF"/>
      <path d="M15.0226 15.5754C14.6908 17.222 13.2601 18.4582 11.5391 18.4582C11.1451 18.4582 10.7667 18.3951 10.409 18.2741L9.62109 20.6676C10.2224 20.8727 10.8704 20.9833 11.5391 20.9833C14.4628 20.9833 16.8991 18.8791 17.459 16.0805L15.0226 15.5754Z" fill="#EE4023"/>
      <path d="M25.5765 17.2694C25.1722 17.6692 24.6279 17.9112 24.0265 17.9007C23.6118 17.8954 23.2283 17.7691 22.9068 17.5587L22.0981 18.8634C22.6528 19.2158 23.3007 19.4262 24.0058 19.4367C25.027 19.4525 25.96 19.0422 26.6392 18.3741L25.5765 17.2694ZM24.1147 11.951C22.0826 11.9194 20.4031 13.5712 20.3719 15.6334C20.3616 16.4067 20.5793 17.1326 20.9681 17.7323L27.6448 14.8337C27.2716 13.2083 25.8409 11.9826 24.1147 11.951ZM21.9012 15.9279C21.8908 15.8437 21.8857 15.7543 21.8857 15.6649C21.9064 14.4497 22.8914 13.4765 24.0888 13.4975C24.7419 13.5081 25.3225 13.8079 25.7112 14.2814L21.9012 15.9279ZM29.7443 10.2676V17.4903L30.9781 18.0111L30.3923 19.4367L29.1689 18.9211C28.8942 18.8002 28.7075 18.616 28.5676 18.4056C28.4328 18.1952 28.3291 17.9006 28.3291 17.5113V10.2676H29.7443ZM34.1972 13.608C34.415 13.5344 34.643 13.4975 34.8867 13.4975C35.939 13.4975 36.8099 14.2551 37.0121 15.2598L38.4998 14.9494C38.1577 13.2398 36.67 11.9562 34.8867 11.9562C34.4772 11.9562 34.0832 12.0246 33.7204 12.1456L34.1972 13.608ZM32.4399 18.495L33.4455 17.343C32.9946 16.9379 32.7146 16.3488 32.7146 15.6912C32.7146 15.0336 32.9997 14.4444 33.4455 14.0446L32.4399 12.8926C31.6779 13.5765 31.1958 14.5812 31.1958 15.6964C31.1958 16.8117 31.6779 17.8112 32.4399 18.495ZM37.0121 16.1383C36.8099 17.1431 35.9338 17.9006 34.8867 17.9006C34.6483 17.9006 34.415 17.8585 34.1972 17.7849L33.7152 19.2473C34.0832 19.3735 34.4772 19.4419 34.8867 19.4419C36.67 19.4419 38.1577 18.1584 38.4998 16.4487L37.0121 16.1383Z" fill="white"/>
      </svg>    
    `,
    hipercard: `
      <svg width="44" height="30" viewBox="0 0 44 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path d="M12.2773 12.9667L12.3998 12.9672L12.4973 12.9335L12.5949 12.8998L12.6811 12.811L12.7674 12.7222L12.8128 12.6038L12.8583 12.4855L12.8598 12.3113L12.8615 12.1372L12.8211 12.0691L12.7807 12.0011L12.7104 11.9569L12.6401 11.9127H12.3364L12.233 11.9597L12.1297 12.0066L12.0697 12.0719L12.0097 12.1372L11.9625 12.2499L11.9154 12.3626L11.9065 12.5382L11.8976 12.7137L11.9414 12.801L11.9854 12.8883L12.07 12.9273L12.1547 12.9662L12.2773 12.9667ZM31.8188 17.9678H32.2597V17.694L32.3104 17.3544C32.3384 17.1677 32.3845 16.8718 32.4129 16.6972C32.4413 16.5224 32.4767 16.3012 32.4916 16.2053C32.5065 16.1095 32.5458 15.902 32.5791 15.7442C32.6125 15.5864 32.654 15.4158 32.6715 15.365C32.689 15.3143 32.7035 15.2611 32.7037 15.2468C32.7039 15.2325 32.7414 15.1404 32.7872 15.0422L32.8704 14.8635L32.9803 14.7155L33.0901 14.5675L33.2102 14.4758C33.2762 14.4254 33.3825 14.3585 33.4464 14.3271L33.5624 14.2701L33.8148 14.2719L34.0672 14.2737L34.1666 14.306L34.266 14.3384L34.2828 14.3279L34.2995 14.3174L34.3004 14.252C34.3009 14.216 34.3224 14.0822 34.3484 13.9546L34.3957 13.7226L34.3426 13.7015C34.2917 13.6823 34.2403 13.6645 34.1885 13.6482L34.0875 13.6158L33.9058 13.6164L33.724 13.6168L33.5759 13.6697L33.4277 13.7226L33.3165 13.7906L33.2053 13.8587L33.0607 14.0124L32.9161 14.1661L32.8384 14.2854C32.7957 14.351 32.7581 14.4017 32.7548 14.3981C32.7515 14.3945 32.7748 14.2578 32.8064 14.0944C32.8381 13.9309 32.8644 13.7765 32.8649 13.7511L32.8657 13.705H32.1185V13.7181C32.1185 13.7252 32.0999 13.8567 32.0771 14.0101C32.0543 14.1636 32.0085 14.4597 31.9755 14.6683C31.9358 14.9177 31.8956 15.1671 31.8548 15.4163C31.8194 15.6318 31.7822 15.8471 31.7433 16.0619C31.7153 16.214 31.6655 16.4816 31.6327 16.6562C31.5998 16.831 31.5459 17.1123 31.5128 17.2814L31.4153 17.7783L31.3781 17.9678H31.8188ZM21.583 17.9678H22.0142L22.0271 17.7827C22.0343 17.681 22.0586 17.4757 22.0814 17.3267C22.1041 17.1777 22.1505 16.8806 22.1846 16.6665C22.2278 16.4017 22.2747 16.1376 22.3255 15.8742C22.3689 15.6527 22.4179 15.4325 22.4344 15.385C22.451 15.3373 22.4646 15.2858 22.4646 15.2704C22.4646 15.2549 22.497 15.1707 22.5366 15.0833C22.5762 14.9959 22.65 14.8621 22.7007 14.7859L22.7927 14.6474L22.9159 14.5316L23.0391 14.4159L23.191 14.3422L23.343 14.2685L23.5753 14.2698L23.8074 14.2711L23.9216 14.3056C23.9844 14.3247 24.0412 14.3403 24.0478 14.3403C24.0544 14.3403 24.0599 14.3185 24.0599 14.2919C24.0599 14.2653 24.0826 14.1303 24.1103 13.9919C24.1381 13.8535 24.1608 13.7345 24.1608 13.7274C24.1608 13.7202 24.095 13.694 24.0144 13.6692C23.9338 13.6444 23.8225 13.6184 23.767 13.6113L23.6661 13.5987L23.5348 13.6223C23.4626 13.6352 23.3552 13.6638 23.2962 13.6859C23.2371 13.7078 23.1397 13.7577 23.0796 13.7967C23.0196 13.8358 22.9261 13.9118 22.872 13.9656C22.8178 14.0195 22.7267 14.1282 22.6696 14.2071C22.6251 14.2685 22.5808 14.3299 22.5368 14.3916L22.5079 14.4325L22.5254 14.3506C22.5351 14.3055 22.562 14.1579 22.5852 14.0227C22.6083 13.8874 22.6323 13.7605 22.638 13.7409L22.6489 13.705H21.8786V13.7544C21.8786 13.7815 21.8559 13.9452 21.8282 14.1181C21.8004 14.2911 21.7545 14.5801 21.7264 14.7605C21.6982 14.9408 21.6481 15.2544 21.6152 15.4573C21.58 15.6728 21.543 15.8881 21.5039 16.1028C21.4279 16.513 21.3501 16.923 21.2706 17.3325C21.2366 17.5073 21.1959 17.7135 21.1803 17.7911C21.1645 17.8686 21.1517 17.9401 21.1517 17.9499V17.9679H21.583V17.9678ZM11.423 17.9678H11.8573L11.8696 17.9355C11.8764 17.9176 11.8819 17.8708 11.8819 17.8316C11.8819 17.7922 11.9092 17.5877 11.9426 17.3772C12.0188 16.8975 12.0969 16.418 12.1769 15.9389C12.2112 15.737 12.2473 15.5354 12.2852 15.3343C12.3173 15.1652 12.3667 14.9024 12.3949 14.7502C12.423 14.5981 12.4784 14.3085 12.518 14.1068C12.5575 13.9051 12.5948 13.7321 12.6008 13.7222L12.6118 13.7042L12.1725 13.7097L11.7332 13.7152L11.6966 13.9817C11.6765 14.1282 11.6325 14.4188 11.5988 14.6272C11.5652 14.8358 11.5143 15.154 11.4857 15.3343C11.4511 15.5498 11.4142 15.7651 11.3751 15.9799C11.3428 16.1546 11.2933 16.422 11.265 16.5742C11.2368 16.7264 11.1862 16.9939 11.1526 17.1686C11.1189 17.3434 11.0738 17.5739 11.0522 17.681C11.0306 17.7881 11.0075 17.8964 11.0007 17.9218L10.9886 17.9678H11.423ZM5.99076 17.9678H6.48141L6.51665 17.7476C6.53598 17.6264 6.57384 17.3934 6.60068 17.2301L6.71174 16.5537C6.74599 16.3451 6.79735 16.0362 6.82583 15.8672C6.85431 15.6981 6.89962 15.4358 6.9264 15.2844C6.95325 15.1328 6.98033 15.0037 6.98651 14.9974L6.99786 14.9859H9.63676L9.65144 15.0008L9.66612 15.0157L9.64317 15.134C9.63065 15.1991 9.59344 15.3999 9.56053 15.5802C9.52763 15.7606 9.4723 16.0649 9.43753 16.2566C9.40102 16.4583 9.36386 16.6598 9.32607 16.8612C9.2994 17.002 9.24547 17.2972 9.20622 17.517C9.16702 17.7368 9.13499 17.9281 9.13511 17.9423L9.13534 17.9678H10.1208L10.1426 17.8398C10.1546 17.7694 10.1738 17.6425 10.1855 17.558C10.197 17.4734 10.225 17.2934 10.2476 17.1583C10.2701 17.0231 10.3151 16.7556 10.3477 16.5639C10.3802 16.3723 10.4347 16.0449 10.4687 15.8364C10.5027 15.6278 10.5531 15.3235 10.5808 15.1601C10.6159 14.9549 10.6524 14.7499 10.6903 14.5452C10.7229 14.3705 10.7772 14.0754 10.8109 13.8893C10.8447 13.7034 10.8952 13.4221 10.9233 13.2642C10.9514 13.1065 11.0025 12.8205 11.037 12.6289C11.0714 12.4373 11.1149 12.2137 11.1336 12.1319L11.1676 11.9833H10.1699L10.1563 12.0807C10.1489 12.1342 10.1248 12.2842 10.1028 12.4138C10.0807 12.5434 10.0408 12.7739 10.0139 12.9261C9.98694 13.0783 9.93779 13.3688 9.9046 13.5717C9.87204 13.7705 9.84071 13.9694 9.8106 14.1686L9.77694 14.3965L9.04461 14.4116L8.31222 14.4266L7.69886 14.4118C7.36149 14.4037 7.08359 14.3954 7.08126 14.3935C7.07899 14.3915 7.09046 14.3119 7.10677 14.2165C7.12825 14.0935 7.15114 13.9708 7.17543 13.8484C7.20641 13.6914 7.23652 13.5343 7.26569 13.377C7.29394 13.2248 7.32585 13.0358 7.33674 12.9569C7.34758 12.878 7.37035 12.7465 7.38729 12.6647C7.40424 12.5831 7.43639 12.4109 7.45875 12.2823C7.48106 12.1536 7.50487 12.0337 7.51169 12.0158L7.52392 11.9833H6.53418L6.50255 12.1627C6.48508 12.2613 6.46185 12.4019 6.4509 12.4752C6.43989 12.5485 6.40303 12.7837 6.36896 12.9978C6.33489 13.212 6.28457 13.5302 6.25714 13.7049L6.14632 14.412C6.10736 14.6582 6.06624 14.9042 6.02309 15.1497C5.98715 15.3515 5.95052 15.553 5.91319 15.7544C5.88693 15.8953 5.8369 16.1627 5.80196 16.3488C5.76533 16.5437 5.72753 16.7384 5.68869 16.9329C5.66132 17.0682 5.63109 17.2249 5.62154 17.2813C5.61187 17.3376 5.58066 17.5002 5.55201 17.6425C5.52341 17.7849 5.5 17.9162 5.5 17.9346V17.9678H5.99076ZM35.3697 18.0675L35.5615 18.0701L35.7433 18.04C35.8433 18.0237 35.9705 17.9971 36.0261 17.9812C36.0816 17.9652 36.1816 17.9238 36.2481 17.8892L36.3694 17.8262L36.4736 17.733L36.5778 17.6399L36.6877 17.4914C36.748 17.4096 36.8027 17.329 36.8091 17.3121L36.8208 17.2813L36.8107 17.3838C36.8034 17.4523 36.7941 17.5207 36.7827 17.5888C36.7729 17.6451 36.7591 17.7535 36.7517 17.8295L36.7383 17.9678H37.5307V17.6912L37.591 17.1686C37.6242 16.8811 37.6733 16.4984 37.7001 16.318C37.7269 16.1375 37.7683 15.8794 37.7921 15.7442C37.8158 15.6089 37.8579 15.3645 37.8855 15.201C37.9132 15.0376 37.9632 14.7517 37.9966 14.5657C38.03 14.3797 38.0835 14.0846 38.1155 13.9099C38.1474 13.7352 38.1971 13.4631 38.2258 13.3053C38.2546 13.1475 38.306 12.8708 38.3402 12.6905C38.376 12.5023 38.413 12.3144 38.4512 12.1268C38.4781 11.9972 38.5001 11.8842 38.5 11.8758V11.8604H37.6355L37.6228 11.9885C37.6158 12.0589 37.5826 12.2918 37.5493 12.506C37.5096 12.7589 37.4693 13.0116 37.4281 13.2642C37.4042 13.41 37.3806 13.5557 37.3571 13.7015L37.3463 13.7698L37.3122 13.7551C37.2934 13.747 37.1917 13.7184 37.0862 13.6915L36.8944 13.6426L36.6318 13.6219L36.3692 13.6011L36.1471 13.6221L35.925 13.6431L35.723 13.695L35.5211 13.7467L35.3292 13.8417L35.1372 13.9367L34.9959 14.0428L34.8545 14.149L34.7324 14.2819C34.6653 14.355 34.5683 14.4758 34.5168 14.5505L34.4234 14.6862L34.3136 14.918C34.2532 15.0455 34.1797 15.2143 34.1503 15.2932C34.1209 15.3722 34.069 15.5471 34.035 15.6819L33.9732 15.9272L33.9427 16.2456L33.9123 16.564L33.9351 16.8201L33.9581 17.0764L33.9851 17.1686C34.0001 17.2193 34.0313 17.3097 34.0548 17.3693L34.0974 17.4781L34.1751 17.5849L34.2529 17.6917L34.3417 17.7654L34.4304 17.8393L34.5516 17.9003C34.6183 17.9338 34.73 17.9773 34.8 17.9967C34.87 18.0162 34.9836 18.0396 35.0525 18.0487C35.1215 18.0577 35.2642 18.0663 35.3697 18.0675ZM35.7141 17.4862L35.5615 17.4943L35.4587 17.4755C35.4021 17.4653 35.3115 17.4374 35.2574 17.4139L35.159 17.3712L35.0762 17.3023L34.9934 17.2335L34.8704 16.9944L34.8424 16.8612L34.8144 16.7279L34.8168 16.4615L34.8191 16.195L34.8517 15.9593L34.8843 15.7237L34.9349 15.5597C34.9628 15.4695 34.9857 15.3844 34.9858 15.3706C34.986 15.3568 35.0134 15.2831 35.0469 15.2067C35.086 15.1184 35.1274 15.031 35.1709 14.9449C35.2058 14.8772 35.2709 14.7718 35.3155 14.7106C35.3603 14.6494 35.44 14.5571 35.4927 14.5056C35.5453 14.4542 35.629 14.3865 35.6788 14.3555L35.7692 14.2991L35.928 14.2433L36.0868 14.1875L36.4201 14.1873H36.7533L36.9451 14.2414C37.0507 14.2711 37.1628 14.3055 37.1941 14.3179L37.2513 14.3404L37.2402 14.3967C37.2341 14.4277 37.21 14.5637 37.1868 14.6989C37.1636 14.8342 37.1179 15.0924 37.0852 15.2728C37.0525 15.4532 37.0023 15.7253 36.9736 15.8774C36.945 16.0295 36.9034 16.2232 36.8813 16.3077C36.8586 16.3946 36.8355 16.4813 36.8121 16.5679C36.796 16.6265 36.7579 16.728 36.7274 16.7934C36.6968 16.8588 36.6433 16.9538 36.6085 17.0045C36.5736 17.0552 36.5148 17.1255 36.4777 17.1607C36.4404 17.1959 36.36 17.2583 36.299 17.2995L36.1879 17.3745L35.8668 17.4779L35.7141 17.4862ZM28.5433 18.0603L28.8159 18.0523L28.9876 18.0077L29.1593 17.963L29.2704 17.9099C29.3315 17.8807 29.4314 17.8227 29.4925 17.7813C29.5536 17.7399 29.6482 17.6612 29.7026 17.6064C29.757 17.5515 29.8379 17.458 29.8821 17.3986C29.9264 17.339 29.9653 17.2931 29.9685 17.2964C29.9719 17.2998 29.9616 17.3944 29.9458 17.5069C29.9302 17.6196 29.9171 17.7693 29.9169 17.8397L29.9165 17.9677H30.6578L30.6691 17.6758L30.6804 17.3837L30.7333 17.0045C30.7624 16.796 30.8094 16.487 30.8378 16.318C30.866 16.149 30.9153 15.8631 30.9472 15.6826C30.9791 15.5023 31.0296 15.221 31.0593 15.0576L31.1136 14.7604L31.1155 14.5037L31.1172 14.247L31.0601 14.1284L31.0029 14.0097L30.9254 13.9342L30.8478 13.8586L30.7205 13.7932L30.5931 13.7276L30.2135 13.642L29.9522 13.6218L29.6909 13.6016L29.3544 13.6228C29.1692 13.6344 28.9088 13.6573 28.7755 13.6738L28.5331 13.7036L28.2028 13.7049L28.1787 13.8228C28.1655 13.8876 28.1288 14.0415 28.0971 14.165C28.0654 14.2884 28.0425 14.3923 28.0461 14.3959C28.0496 14.3996 28.138 14.3792 28.2423 14.3507C28.3467 14.3222 28.5685 14.2754 28.7351 14.2465L29.038 14.1942L29.3107 14.1828L29.5834 14.1714L29.9346 14.2339L30.0518 14.2926L30.1691 14.3513L30.2347 14.4506L30.3004 14.5498L30.2994 14.7063L30.2985 14.8629L30.2636 15.0346L30.2288 15.2064L29.5021 15.2091L28.7754 15.2117L28.5376 15.2779C28.4068 15.3143 28.262 15.3626 28.2157 15.3853C28.1695 15.408 28.1232 15.4265 28.1129 15.4265C28.1027 15.4265 28.0249 15.4702 27.94 15.5238L27.7858 15.6211L27.6644 15.7441C27.5975 15.8118 27.5122 15.9132 27.4747 15.9696C27.4371 16.0259 27.3762 16.1436 27.3393 16.2313L27.2721 16.3904L27.2413 16.5693L27.2104 16.7483V17.1239L27.2398 17.2802L27.2694 17.4365L27.324 17.5386C27.3541 17.5946 27.4094 17.6768 27.4466 17.7211L27.5147 17.8018L27.6354 17.8762L27.7562 17.9507L27.8945 17.9903C27.9705 18.0121 28.0863 18.0386 28.1517 18.0491L28.2706 18.0682L28.5433 18.0602V18.0603ZM28.7958 17.4872L28.6342 17.4957L28.5272 17.468C28.4684 17.4529 28.379 17.419 28.3288 17.3928L28.2374 17.345L28.1874 17.2848C28.16 17.2516 28.1181 17.1866 28.0942 17.1402L28.051 17.0558L28.0425 16.8589L28.034 16.6619L28.0682 16.5423C28.087 16.4766 28.1312 16.3625 28.1665 16.2888L28.2304 16.1549L28.3529 16.0315L28.4753 15.9081L28.6053 15.8446L28.7353 15.7811L28.8968 15.7421L29.0584 15.7032H30.0682L30.1002 15.7166L30.1321 15.7299L30.1052 15.8908C30.0904 15.9792 30.0552 16.1392 30.0268 16.2463C29.9985 16.3534 29.9485 16.5108 29.9158 16.5961C29.883 16.6815 29.8561 16.7569 29.8561 16.7637C29.8561 16.7706 29.8229 16.8327 29.7824 16.9019L29.7086 17.0276L29.5875 17.1494C29.5209 17.2163 29.459 17.2711 29.4501 17.2711C29.4412 17.2711 29.4004 17.2943 29.3594 17.3224L29.285 17.3735L29.1212 17.4262L28.9574 17.4787L28.7958 17.4872ZM25.2212 18.0679L25.4435 18.0703L25.6958 18.0399C25.8346 18.0233 26.0193 17.9956 26.1064 17.9784C26.2115 17.957 26.316 17.9318 26.4194 17.9031C26.5045 17.8786 26.5816 17.8522 26.5906 17.8444C26.5996 17.8366 26.6236 17.7435 26.644 17.6377C26.6645 17.5319 26.6901 17.3899 26.7011 17.3223C26.7121 17.2547 26.7178 17.1957 26.7138 17.1913C26.7097 17.1868 26.6949 17.1926 26.6807 17.2039C26.6665 17.2154 26.5675 17.2577 26.4605 17.298L26.2661 17.3713L25.9891 17.4258L25.7121 17.4801L25.4767 17.472L25.2413 17.4638L25.1075 17.4167L24.9737 17.3696L24.8704 17.278L24.7671 17.1862L24.6985 17.0594L24.63 16.9328L24.5973 16.7632L24.5646 16.5938L24.5649 16.3739L24.5651 16.154L24.6047 15.8875L24.6444 15.6211L24.6864 15.4776C24.7095 15.3987 24.7357 15.3065 24.7445 15.2727C24.7533 15.2388 24.7903 15.142 24.8268 15.0574C24.8632 14.9729 24.9282 14.8423 24.9711 14.7671L25.0493 14.6305L25.1453 14.5295L25.2413 14.4285L25.3429 14.3646L25.4447 14.3006L25.5752 14.2597C25.647 14.2373 25.774 14.2081 25.8573 14.195L26.0088 14.171L26.2309 14.1824L26.4531 14.1936L26.7156 14.247L26.9782 14.3003L27.0849 14.3407C27.1436 14.3629 27.1942 14.3812 27.1974 14.3812C27.2006 14.3812 27.2147 14.305 27.2287 14.212C27.2428 14.1191 27.2678 13.9661 27.2844 13.8721C27.301 13.778 27.3105 13.697 27.3056 13.6921C27.3008 13.6872 27.2218 13.6745 27.1303 13.6639C27.0387 13.6533 26.7897 13.6345 26.5772 13.622L26.1905 13.5995L25.9178 13.6207L25.6452 13.642L25.4432 13.685L25.2412 13.7281L25.1112 13.7809C25.0396 13.8099 24.9349 13.8623 24.8783 13.8973C24.8241 13.9308 24.7708 13.9656 24.7185 14.0019C24.687 14.0245 24.5917 14.1124 24.5066 14.1974L24.352 14.3519L24.2655 14.4803C24.2181 14.5509 24.136 14.6981 24.083 14.8074L23.9868 15.0063L23.913 15.2214C23.8725 15.3398 23.8158 15.5334 23.7872 15.6518L23.7351 15.867L23.7162 16.0617L23.6973 16.2564L23.6975 16.5126L23.6977 16.7687L23.7168 16.9178L23.7358 17.0668L23.7963 17.2201L23.8568 17.3734L23.9267 17.4842L23.9965 17.595L24.1075 17.7061L24.2187 17.817L24.3362 17.8801L24.4538 17.943L24.6082 17.9866C24.693 18.0105 24.8157 18.038 24.8808 18.0476C24.9459 18.0572 25.0991 18.0662 25.2214 18.0676H25.2212V18.0679ZM18.7988 18.0678L19.021 18.0703L19.2431 18.0497C19.3654 18.0385 19.5652 18.0149 19.6873 17.9973C19.8096 17.9799 20.0207 17.9408 20.1565 17.9105L20.4034 17.8554L20.4157 17.763C20.4224 17.7122 20.4502 17.561 20.4773 17.427L20.5267 17.1832L20.5157 17.1722L20.5048 17.1612L20.4293 17.1981C20.3878 17.2185 20.2585 17.267 20.142 17.3059L19.9301 17.3767L19.7078 17.4205L19.4854 17.4641L19.1321 17.465L18.7786 17.4655L18.6574 17.4263C18.5908 17.4047 18.4928 17.3653 18.4396 17.3385L18.343 17.29L18.1835 17.1436L18.1212 17.0333L18.059 16.9228L18.02 16.7844L17.9809 16.6459L17.9807 16.3896L17.9804 16.1334L18.015 15.9049L18.0498 15.6762L18.6575 15.6474L19.781 15.6547L20.9044 15.662L20.9383 15.516C20.957 15.4357 20.9855 15.2697 21.0017 15.1471L21.0312 14.9242L21.0318 14.7368L21.0325 14.5492L21.0005 14.4092L20.9684 14.2693L20.9156 14.1766C20.8866 14.1257 20.8352 14.0518 20.8017 14.0124C20.7682 13.9731 20.7082 13.9177 20.6686 13.8893C20.6288 13.8609 20.5509 13.813 20.4954 13.7831L20.3945 13.7286L20.2181 13.6854L20.0416 13.6424L19.8243 13.6213L19.6069 13.6002L19.405 13.6135L19.203 13.6268L18.9606 13.674L18.7183 13.7213L18.5667 13.7827C18.4834 13.8165 18.3562 13.8782 18.2841 13.9197C18.2118 13.9613 18.1119 14.0289 18.062 14.0699C18.0119 14.1111 17.9253 14.191 17.8696 14.2475C17.8138 14.3042 17.7312 14.4057 17.6863 14.4734C17.6412 14.541 17.5721 14.6609 17.5326 14.7398C17.4933 14.8187 17.4419 14.9294 17.4186 14.9857C17.3954 15.0421 17.3528 15.1574 17.3244 15.2419C17.2959 15.3265 17.251 15.4879 17.2249 15.6006C17.194 15.7372 17.1674 15.8747 17.1449 16.0129L17.1127 16.2203L17.113 16.5253L17.1134 16.8302L17.144 16.9634C17.1608 17.0367 17.1932 17.1474 17.2157 17.2094C17.2382 17.2714 17.28 17.3636 17.3085 17.4144C17.3369 17.4651 17.3977 17.5467 17.4435 17.5959C17.4892 17.6449 17.5722 17.7195 17.6277 17.7614C17.6832 17.8033 17.7821 17.8624 17.8473 17.8925L17.9661 17.9474L18.1317 17.988C18.2227 18.0104 18.3601 18.0369 18.437 18.0469C18.5138 18.057 18.6767 18.0664 18.7988 18.0678ZM19.1792 15.1806C18.6201 15.1806 18.1626 15.1766 18.1626 15.1716C18.1626 15.1667 18.1865 15.0951 18.2157 15.0127C18.2448 14.9303 18.2961 14.8077 18.3294 14.7402L18.3903 14.6175L18.5238 14.4827L18.6574 14.3478L18.7887 14.2841C18.8609 14.2491 18.9563 14.2109 19.0008 14.1993C19.0453 14.1877 19.1724 14.1724 19.2835 14.1652L19.4855 14.152L19.6406 14.1723L19.7957 14.1925L19.9084 14.2449L20.0212 14.2972L20.083 14.3649C20.117 14.4021 20.1574 14.4569 20.173 14.4866L20.2012 14.5407L20.2198 14.6608L20.2385 14.7809L20.2171 14.9807L20.1958 15.1806H19.1792ZM13.1697 19.8739L13.1819 19.8414C13.1887 19.8237 13.1942 19.7818 13.1942 19.7483C13.1942 19.715 13.2085 19.5935 13.226 19.4786C13.2435 19.3634 13.2845 19.0987 13.3172 18.8902C13.3499 18.6817 13.3988 18.368 13.426 18.1934C13.4518 18.0279 13.4763 17.8622 13.4996 17.6964C13.513 17.5977 13.5292 17.517 13.5358 17.517C13.5423 17.517 13.5704 17.5606 13.5982 17.6139L13.6486 17.7107L13.7605 17.8253L13.8725 17.9398L14.0103 17.9958L14.1482 18.0517L14.3124 18.0733L14.4767 18.0949L14.6851 18.0819L14.8936 18.0689L15.1193 18.0097L15.3451 17.9503L15.4663 17.8942C15.5329 17.8635 15.651 17.796 15.7288 17.7447L15.8702 17.6513L16.002 17.5175C16.0745 17.4441 16.1767 17.3261 16.2292 17.2554C16.2817 17.1849 16.3246 17.122 16.3246 17.1158C16.3246 17.1095 16.3504 17.0658 16.3819 17.0186C16.4134 16.9715 16.4778 16.8406 16.5251 16.7279C16.5725 16.6153 16.6463 16.4123 16.6894 16.2771L16.7677 16.0311L16.8082 15.8181C16.8304 15.701 16.8591 15.5073 16.8718 15.3877L16.8949 15.1704L16.8815 14.9859L16.8682 14.8015L16.826 14.617L16.7839 14.4325L16.7156 14.2945L16.6474 14.1564L16.5156 14.0146L16.3839 13.8728L16.0721 13.7093L15.9004 13.6675L15.7287 13.6259L15.557 13.6131L15.3854 13.6003L15.1942 13.6226L15.0029 13.6449L14.8469 13.6854L14.6908 13.7258L14.5552 13.7895C14.4806 13.8245 14.3721 13.884 14.3141 13.9217C14.256 13.9594 14.1961 14.0027 14.181 14.018C14.1659 14.0333 14.1296 14.0617 14.1005 14.081L14.0474 14.1163L14.0845 13.9362C14.1049 13.8372 14.1219 13.7447 14.1224 13.7305L14.1232 13.705H13.3826L13.3178 14.12C13.282 14.3483 13.2256 14.701 13.1924 14.904C13.1192 15.3516 13.0452 15.799 12.9702 16.2463C12.9372 16.4435 12.8826 16.7571 12.8489 16.9432C12.8152 17.1291 12.7658 17.4012 12.7392 17.5478C12.7126 17.6943 12.6624 17.9709 12.6278 18.1625C12.5869 18.388 12.5457 18.6135 12.5041 18.8389C12.4646 19.0508 12.4243 19.2625 12.3833 19.4742C12.3502 19.6432 12.3183 19.8024 12.3122 19.8276L12.3012 19.8738H13.1697V19.8739ZM14.4363 17.5147L14.3261 17.4948L14.2158 17.4751L14.1039 17.4232L13.9919 17.3714L13.9138 17.2956L13.8356 17.2199L13.7904 17.1174C13.7655 17.0611 13.7337 16.9653 13.7195 16.9045L13.6938 16.7943L13.7041 16.6177L13.7145 16.4411L13.7665 16.1644C13.8057 15.9528 13.8438 15.741 13.8806 15.5291C13.9148 15.3318 13.9666 15.0427 13.9957 14.8868L14.0485 14.6031L14.1643 14.5053C14.228 14.4516 14.3289 14.3795 14.3885 14.3452L14.4968 14.2828L14.6382 14.2384L14.7796 14.194L15.1431 14.1724L15.2911 14.2044L15.4391 14.2364L15.5436 14.2852L15.648 14.334L15.7356 14.4234L15.8232 14.5127L15.8704 14.6073C15.8964 14.6594 15.933 14.7612 15.9515 14.8337L15.9854 14.9654L15.975 15.3549L15.9646 15.7443L15.9128 15.9745C15.8843 16.1011 15.83 16.2948 15.7921 16.4048L15.7234 16.6051L15.639 16.7671C15.5927 16.8564 15.5212 16.9767 15.4802 17.0348C15.4392 17.0928 15.3738 17.1682 15.3349 17.202C15.2878 17.2427 15.2396 17.2819 15.1903 17.3197L15.1162 17.3758L14.7735 17.4941L14.4363 17.5147Z" fill="white"/>
      </svg>
    `,
    outros: `
      <svg width="44" height="30" viewBox="0 0 44 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0H2C0.89543 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H42C43.1046 30 44 29.1046 44 28V2C44 0.89543 43.1046 0 42 0Z" fill="#4F44E0"/>
      <path d="M0.5 5.38379H43.5V10.6629H0.5V5.38379Z" fill="white" stroke="white"/>
      <path d="M5 21.5H11C11.2761 21.5 11.5 21.7239 11.5 22V24C11.5 24.2761 11.2761 24.5 11 24.5H5C4.72386 24.5 4.5 24.2761 4.5 24V22C4.5 21.7239 4.72386 21.5 5 21.5Z" fill="white" stroke="white"/>
      </svg>    
    `,
  }

  if (!brand) {
    return svg.outros
  }

  const brandKey = brand.toLowerCase().replace(/\s/g, '').trim()
  const brandSvg = svg[brandKey]

  if (!brandSvg) {
    return svg.outros
  } else {
    return brandSvg
  }
}

export const formataData = (config) => {
  try {
    const objetoRetorno = {}

    if (!config) {
      console.error('As configurações são obrigatórias para esta função')
      return ''
    }

    if (!config.index) {
      config.index = {
        dia: 0,
        mes: 1,
        ano: 2,
      }
    }

    if (config.data) {
      if (typeof config.data === 'string') {
        const separador = config.separador ? config.separador : config.data[2]
        const dataArray = config.data.split(separador)

        const dia = dataArray[config.index.dia]
        const mes = dataArray[config.index.mes]
        const ano = dataArray[config.index.ano]

        objetoRetorno.data = new Date(ano, mes - 1, dia)

        if (config.hora) {
          const separador = config.separadorHora
            ? config.separadorHora
            : config.hora[2]
          const [horas, minutos, segundos] = config.hora.split(separador)

          if (horas) {
            objetoRetorno.data.setHours(horas)

            if (minutos) {
              objetoRetorno.data.setMinutes(minutos)

              if (segundos) {
                objetoRetorno.data.setSeconds(segundos)
              }
            }
          }
        }
      } else if (typeof config.data === 'object') {
        objetoRetorno.data = config.data
        objetoRetorno.dataString = config.data
          .toLocaleString()
          .substring(0, 10)
          .trim()
        objetoRetorno.dataStringInvertida = config.data
          .toLocaleString()
          .substring(0, 10)
          .split('/')
          .reverse()
          .join('/')
      }

      if (config.add) {
        if (config.add.horas) {
          objetoRetorno.data.setHours(
            objetoRetorno.data.getHours() + Number(config.add.horas),
          )
          objetoRetorno.data.setHours(hora)
        }

        if (config.add.minutos) {
          objetoRetorno.data.setMinutes(
            objetoRetorno.data.getMinutes() + Number(config.add.minutos),
          )
          objetoRetorno.data.setMinutes(minutos)
        }

        if (config.add.segundos) {
          objetoRetorno.data.setSeconds(
            objetoRetorno.data.getSeconds() + Number(config.add.segundos),
          )
          objetoRetorno.data.setSeconds(segundos)
        }
      }
    }

    return objetoRetorno
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
    return {}
  }
}

export function parseFloatBr(value) {
  try {
    const replaced = value.replace('.', '').replace(',', '.')
    return Number(replaced)
  } catch (error) {
    Sentry.captureException(error)
  }
}

export function coockie() {
  let config = localStorage.getItem('cookie-preferences')

  if (config) {
    config = JSON.parse(config)
  }
}

export const formatMoney = (val, onlyValue) => {
  const value = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(val)

  return onlyValue ? value.substring(3, value.length) : value
}

export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    // Fallback para navegadores que não suportam a API do Clipboard
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    toast('Copiado com sucesso!')
    console.log('Texto copiado para a área de transferência!')
    return Promise.resolve()
  }

  return navigator.permissions
    .query({ name: 'clipboard-write' })
    .then(function (result) {
      if (result.state === 'granted' || result.state === 'prompt') {
        return navigator.clipboard.writeText(text).then(
          function () {
            toast('Copiado com sucesso!')
            console.log('Texto copiado para a área de transferência!')
          },
          function (err) {
            toast('Erro ao copiar o texto')
            return Promise.reject(err)
          },
        )
      } else {
        toast(
          'Acesso negado para a área de transferência! Por favor, conceda permissão para acessar a área de transferência.',
        )
        console.error('Acesso negado para a área de transferência!')
        return Promise.reject(
          new Error('Acesso negado para a área de transferência!'),
        )
      }
    })
}

export function prevent(event) {
  event.preventDefault()
  event.stopPropagation()
}

export function decimalStringToNumber(value) {
  return Number(value.replaceAll('.', '').replace(',', '.'))
}

export function convertBRDateToAmerican(dateBR) {
  if (!dateBR) {
    return ''
  }

  if (dateBR.includes('-')) {
    return dateBR
  }

  // A data BR está no formato "dd/mm/aaaa"
  const parts = dateBR.split('/')

  // Inverte as partes da data e junta com "-"
  var dateAmerican = parts[2] + '-' + parts[1] + '-' + parts[0];
  return dateAmerican;

}

export function convertAmericanDateToBR(dateAmerican) {

  if (!dateAmerican) {
    return ""
  }

  if (dateAmerican.includes('/')) {
    return dateAmerican
  }

  // A data BR está no formato "aaaa-mm-dd"
  var parts = dateAmerican.split('-');

  // Inverte as partes da data e junta com "/"
  var dateBR = parts[2] + '/' + parts[1] + '/' + parts[0];
  return dateBR;
}

export function Step(step = {
  step: 0,
  statusClass: 'pendente',
  description: 'Descrição'
}) {

  const stepWrapper = createElement('div', {},
    `
  <div class="border-dashed"></div>
  <div class="step ${step.statusClass}" step='${step.step}'>
    <div class="loader">
      <div class="showbox">
        <div class="loader"> 
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>
      </div>
    </div>
    <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7" fill="#D9D9D9" />
      <path
        d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z"
        fill="#24292E" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z"
        fill="#24292E" />
    </svg>
    <div>${step.description}</div>
  </div>
  `,
  )

  const changeStatus = (status) => {
    stepWrapper.querySelector('.step').classList.remove(step.statusClass)
    stepWrapper.querySelector('.step').classList.add(status)
    step.statusClass = status
  }

  return {
    component: stepWrapper,
    changeStatus,
  }
}

export function Check() {
  return `
   <svg class="check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7" fill="#D9D9D9"/>
                    <path d="M11.4812 6.25551C11.4846 6.44981 11.4125 6.63785 11.28 6.78003L7.77997 10.28C7.63934 10.4205 7.44872 10.4994 7.24997 10.4994C7.05122 10.4994 6.86059 10.4205 6.71997 10.28L4.71997 8.28003C4.58749 8.13785 4.51537 7.94981 4.51879 7.75551C4.52222 7.56121 4.60093 7.37582 4.73835 7.23841C4.87576 7.10099 5.06115 7.02228 5.25545 7.01885C5.44975 7.01543 5.63779 7.08755 5.77997 7.22003L7.24997 8.69003L10.22 5.72003C10.3622 5.58755 10.5502 5.51543 10.7445 5.51885C10.9388 5.52228 11.1242 5.60099 11.2616 5.73841C11.399 5.87582 11.4777 6.06121 11.4812 6.25551Z" fill="#24292E"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569ZM12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962Z" fill="#24292E"/>
                </svg>`
}

export const enableSaveOrderButton = () => {
  const botaoSalvarPedido = document.querySelector('#salva-pedido');
  if (botaoSalvarPedido) {
    botaoSalvarPedido.textContent = 'Enviar pedido';
    botaoSalvarPedido.removeAttribute('disabled');
  }
}